import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class ChannelEditForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		var Validator = validatorjs;
		Validator.register(
			'time',
			value => {
				var res = value.split(':');
				var hours = false;
				var minutes = false;
				if (!res[0].includes('H') && res[0] <= 23) {
					hours = true;
					if (!res[1].includes('m') && res[1] <= 59) {
						minutes = true;
					}
				}
				if (hours && minutes) {
					return true;
				}
				return false;
			},
			'INVALIDTIME'
		);
		return {
			fields: [
				{
					name: 'seller',
					label: 'CHANNEL.SELLER',
				},
				{
					name: 'name',
					label: 'CHANNEL.NAME',
					rules: 'required|string',
				},
				{
					name: 'timezone',
					label: 'CHANNEL.TIMEZONE',
					rules: 'required',
				},
				{
					name: 'channelType',
					label: 'CHANNEL.CHANNELTYPE',
					rules: 'required',
				},
				{
					name: 'carrierChannels',
					label: 'CHANNEL.REQUIREDCARRIERS.LABEL',
					placeholder: 'CHANNEL.REQUIREDCARRIERS.PLACEHOLDER',
					rules: 'required',
				},
				{
					name: 'apiKey',
					label: 'CHANNEL.APIKEY',
					rules: 'string',
				},
				{
					name: 'apiSecret',
					label: 'CHANNEL.APISECRET',
					rules: 'string',
				},
				{
					name: 'amazonSellerId',
					label: 'CHANNEL.SELLERID',
					rules: 'string',
				},
				{
					name: 'marketplaceId',
					label: 'CHANNEL.MARKETPLACEID',
					rules: 'string',
				},
				{
					name: 'token',
					label: 'CHANNEL.TOKEN',
					rules: 'string',
				},
				{
					name: 'developerId',
					label: 'CHANNEL.DEVELOPERID',
					rules: 'string',
				},
				{
					name: 'certificateId',
					label: 'CHANNEL.CERTIFICATEID',
					rules: 'string',
				},
				{
					name: 'applicationId',
					label: 'CHANNEL.APPLICATIONID',
					rules: 'string',
				},
				{
					name: 'url',
					label: 'CHANNEL.URL',
					rules: 'string',
				},
				{
					name: 'consumerKey',
					label: 'CHANNEL.CONSUMERKEY',
					rules: 'string',
				},
				{
					name: 'shopId',
					label: 'CHANNEL.SHOPID',
					rules: 'string',
				},
				{
					name: 'consumerSecret',
					label: 'CHANNEL.CONSUMERSECRET',
					rules: 'string',
				},
				{
					name: 'refreshToken',
					label: 'CHANNEL.REFRESHTOKEN',
				},
				{
					name: 'accessToken',
					label: 'CHANNEL.ACCESSTOKEN',
				},
				{
					name: 'partnerId',
					label: 'CHANNEL.PARTNERID',
				},
				{
					name: 'shouldAcknowledgeOrders',
					label: 'CHANNEL.SHOULDACKNOWLEDGE',
					value: true,
				},
				{
					name: 'shouldAutoCancel',
					label: 'CHANNEL.SHOULDAUTOCANCEL',
					value: false,
				},
				{
					name: 'useConfirmShipment',
					label: 'CHANNEL.USECONFIRMSHIPMENT',
					value: true,
				},
				{
					name: 'sellingPartyId',
					label: 'CHANNEL.SELLINGPARTYID',
				},
				{
					name: 'useSandbox',
					label: 'CHANNEL.USESANDBOX',
					value: false,
				},
				{
					name: 'checkBuyShippingSunday',
					label: 'CHANNEL.CHECKBUYSHIPPINGSUNDAY',
					value: true,
				},
				{
					name: 'useBuyShippingForPrime',
					label: 'CHANNEL.USEBUYSHIPPINGFORPRIME',
					value: false,
				},
				{
					name: 'useBuyShippingForNonPrime',
					label: 'CHANNEL.USEBUYSHIPPINGFORNONPRIME',
					value: false,
				},
				{
					name: 'useAmazonMli',
					label: 'CHANNEL.USEAMAZONMLI',
					value: false,
				},
				{
					name: 'userName',
					label: 'CHANNEL.USERNAME',
				},
				{
					name: 'password',
					label: 'CHANNEL.PASSWORD',
				},
				{
					name: 'channelId',
					label: 'CHANNEL.CHANNELID',
				},
				{
					name: 'serverId',
					label: 'CHANNEL.SERVERID',
				},
			],
		};
	}
	options() {
		return {
			validateOnBlur: false,
			showErrorsOnReset: false,
			validateOnChange: true,
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/channel/forms/ChannelEditForm.js